(() => {
  const fr1Handle = '/products/simmons-20-inch-simmons-fr1';
  const visibleLimit = 6;

  function installStyles() {
    if (document.getElementById('ea-fr1-gallery-more-style')) return;
    const style = document.createElement('style');
    style.id = 'ea-fr1-gallery-more-style';
    style.textContent = `
      media-gallery .thumbnail-list__item.ea-fr1-gallery-hidden,
      media-gallery .product__media-item.ea-fr1-gallery-hidden { display: none !important; }
      media-gallery .ea-fr1-gallery-more-item { display: block !important; }
      media-gallery .ea-fr1-gallery-more-button {
        display: grid !important;
        place-items: center !important;
        width: 100% !important;
        height: 100% !important;
        min-height: 72px !important;
        color: #fff !important;
        font-size: 1.5rem !important;
        font-weight: 800 !important;
        letter-spacing: 0 !important;
        border-radius: 6px !important;
        border: 1px solid rgba(0, 0, 0, .22) !important;
        background: radial-gradient(circle at center, rgba(40, 40, 40, .58), rgba(15, 15, 15, .86)) !important;
        box-shadow: inset 0 0 24px rgba(255, 255, 255, .18), 0 8px 18px rgba(17, 17, 17, .12) !important;
        cursor: pointer !important;
      }
      media-gallery .ea-fr1-gallery-more-button--main {
        aspect-ratio: 1.333 / 1;
        min-height: 220px !important;
        font-size: clamp(2rem, 5vw, 4rem) !important;
      }
      media-gallery.ea-fr1-gallery-ready .product__media-list {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 1.5rem !important;
        overflow: visible !important;
        scroll-snap-type: none !important;
      }
      media-gallery.ea-fr1-gallery-ready .product__media-list > .product__media-item {
        width: auto !important;
        max-width: none !important;
        transform: none !important;
        scroll-snap-align: unset !important;
      }
      @media screen and (max-width: 749px) {
        media-gallery.ea-fr1-gallery-ready .product__media-list {
          grid-template-columns: 1fr !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function isFr1Page() {
    return window.location.pathname.toLowerCase() === fr1Handle;
  }

  function applyFr1GalleryMore() {
    if (!isFr1Page()) return;
    installStyles();

    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.eaFr1GalleryReady === 'true') return;

      const list = gallery.querySelector('.thumbnail-list') || gallery.querySelector('.product__media-list');
      if (!list) return;

      const usesMainMediaList = list.classList.contains('product__media-list');
      const oldMore = list.querySelector('.ea-fr1-gallery-more-item');
      if (oldMore) oldMore.remove();

      const items = usesMainMediaList
        ? Array.from(list.querySelectorAll(':scope > .product__media-item'))
        : Array.from(list.querySelectorAll(':scope > .thumbnail-list__item'));
      items.forEach((item) => item.classList.remove('ea-fr1-gallery-hidden'));

      if (items.length <= visibleLimit) {
        gallery.dataset.eaFr1GalleryReady = 'true';
        gallery.classList.add('ea-fr1-gallery-ready');
        return;
      }

      const moreCount = items.length - visibleLimit;
      items.slice(visibleLimit).forEach((item) => item.classList.add('ea-fr1-gallery-hidden'));

      const moreItem = document.createElement('li');
      moreItem.className = usesMainMediaList
        ? 'product__media-item grid__item slider__slide ea-fr1-gallery-more-item'
        : 'thumbnail-list__item slider__slide ea-fr1-gallery-more-item';

      const moreButton = document.createElement('button');
      moreButton.type = 'button';
      moreButton.className = usesMainMediaList
        ? 'ea-fr1-gallery-more-button ea-fr1-gallery-more-button--main'
        : 'thumbnail global-media-settings global-media-settings--no-shadow ea-fr1-gallery-more-button';
      moreButton.setAttribute('aria-label', `Show ${moreCount} more wheel images`);
      moreButton.textContent = `+${moreCount}`;

      moreButton.addEventListener('click', () => {
        items.forEach((item) => item.classList.remove('ea-fr1-gallery-hidden'));
        moreItem.remove();
        gallery.classList.add('ea-fr1-gallery-expanded');
      });

      moreItem.appendChild(moreButton);
      list.appendChild(moreItem);
      gallery.dataset.eaFr1GalleryReady = 'true';
      gallery.classList.add('ea-fr1-gallery-ready');
    });
  }

  document.addEventListener('DOMContentLoaded', applyFr1GalleryMore);
  document.addEventListener('shopify:section:load', applyFr1GalleryMore);
})();
